'use client';

import OopsError from './components/OopsError';

const GlobalError = () => {
  return <OopsError hideHeaderFooter={true} />;
};

export default GlobalError;
